import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";

import Select from "react-select";
import { CSVLink } from "react-csv";

import jQuery from "jquery";
export default function GetDriverOrders() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState("");
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const $ = jQuery.noConflict();

  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");
    });
  }, []);

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };
  const buttonsyle1 = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginLeft: "75%",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
    marginBottom: "2%",
  };

  const [msg, setMsg] = useState("");
  const [errormsg, setError] = useState("");

  useEffect(() => {
    // Fetch drivers from the API on component mount
    fetchDrivers();
    getUserList();
  }, []);

  const [scaninfo, setScaninfo] = useState({
    driver: "",
  });
  const [drivers, setDrivers] = useState();
  const [awb, setAwb] = useState();
  const fetchDrivers = async () => {
    try {
      // Replace this API endpoint with the actual one that fetches drivers based on the emirate
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getAllDrivers`
      );

      if (response.data.success) {
        const driversData = response.data.data; // The array of driver objects

        // Map the response to extract driverId and name
        const driversList = driversData.map((driver) => ({
          driver_id: driver.driverId,
          driver_name: driver.name,
        }));

        // Set the drivers state
        setDrivers(driversList);
      } else {
        console.error("Error fetching drivers for emirate:");
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  };

  const [users, setusers] = useState();
  const getUserList = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

    // Send a GET request to the new API
    try {
      const res = await axios.get(API_PATH);

      console.log(res.data); // Log the response to inspect it

      // Check if the response contains 'data' and if it's an array
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setusers(res.data.data); // Update the personnel list in the state
      } else {
        console.log(
          "No personnel data found in the response or response is not successful"
        );
      }
    } catch (err) {
      console.log("Error fetching personnel list:", err);
    }
  };

  console.log("drivers:", drivers);
  console.log("scan:", scaninfo);
  console.log("users:", users);

  const getDetails = async () => {
    try {
      const response = await axios.post(
        `${API_URL}shypvdriverapp/jobs/assignedOrderDriverDetails`,
        {
          driverId: driver,
          date: datechosen,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response Data:", response.data);

      // Handle response data
      if (response.data.success) {
        setShipmentDetails(response.data.data || []);
        fetchDriverInfo(driver);
        if (response.data.data.length === 0) {
          setError("Booking details not found");
        } else {
          setError("");
        }
      } else {
        setShipmentDetails([]);
        setError("Booking details not found");
      }
    } catch (err) {
      console.error("Error:", err.response || err.message);
      setError("An error occurred while fetching details");
    }
  };

  const [driverdata, setdriverdata] = useState({
    driverid: "",
    team: "",
    zone: "",
  });
  const fetchDriverInfo = async (driverId) => {
    try {
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getDriver`,
        {
          params: { driverId },
        }
      );

      console.log("Driver Info:", response.data);
      if (response.data.success) {
        const driverInfo = response.data.data;

        setdriverdata({
          driverid: driverInfo.driverId || "",
          team: driverInfo.team?.teamName || "",
          zone: `${driverInfo.zone?.district || ""} - ${
            driverInfo.zone?.emirates || ""
          }`,
        });
      } else {
        setdriverdata({ driverid: driverId, team: "", zone: "" });
      }
      // Optionally update state or show UI
      // setDriverDetails(response.data);
    } catch (error) {
      console.error("Error fetching driver info:", error);
      setdriverdata({ driverid: driverId, team: "", zone: "" });
    }
  };

  const [errorNew, seterrorNew] = useState("");

 

  const [allStatus, setallStatus] = useState();
  useEffect(() => {
    // Make the API call when the component mounts
    axios
      .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
      .then((response) => {
        setallStatus(response.data.data); // Store the data in state
        setLoading(false); // Set loading to false when done
      })
      .catch((err) => {
        setError(err); // Store the error in state if something goes wrong
        setLoading(false); // Set loading to false even if there's an error
      });
  }, []);

  console.log("all", allStatus);

  //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
  const [newStatus, setnewStatus] = useState(0);
  // Handle status change
  const handleStatusChange = (index, newStatus) => {
    setnewStatus(newStatus);
    // Create a copy of the current shipment details
    const updatedShipmentDetails = [...shipmentDetails];

    // Update the status at the specified index
    updatedShipmentDetails[index].status = newStatus;

    // Update the state with the new shipment details array
    setShipmentDetails(updatedShipmentDetails);
  };

  const handleAwbChange = (e) => {
    // Update the input field value
    setAwb(e.target.value);
  };

  function resetData() {
    setShipmentDetails([]);
    setAwb("");
  }
  console.log("shipmentDetails", shipmentDetails);

  const [datechosen, setdatechosen] = useState();
  const [driver, setdriverchosen] = useState();

  const totalCod =
    shipmentDetails &&
    shipmentDetails
      .filter((data) => data.latestStatus?.toLowerCase() === "delivered")
      .reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

  const csvHeaders2 = [
    { label: "AWB", key: "bookingId" },
    { label: "Status", key: "latestStatus" },
    { label: "Last Transit Date", key: "lastTransitDate" },
    { label: "Last Transit Time", key: "lastTransitTime" },
    { label: "Courier", key: "courier" },
    { label: "Courier team", key: "courier_team" },
    { label: "Courier zone", key: "courier_zone" },
    { label: "Shipper", key: "shipper" },
    { label: "Consignee", key: "consignee" },
    { label: "Payment Type", key: "paymentType" },
    { label: "COD", key: "codDetails" },
    { label: "Collection", key: "actualCollected" },
    { label: "Cash Difference", key: "cashDifference" },
    { label: "Updated By", key: "updatedBy" },
  ];

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  function editStatus(orderid, codamt) {
    const collectedValue = actualCollectedMap[orderid];
    // alert(`Order ID: ${orderid}\n cod :${codamt} Actual Collected: ₹${collectedValue ?? 'Not entered'} ${driver}`);

    axios
      .post(`${API_URL}shypvdriverapp/jobs/reconcileCod`, {
        bookingId: orderid,
        codAmount: codamt,
        codCollectedAmount: collectedValue,
        driverId: driver,
      })
      .then((res) => {
        console.log(res.data);

        if (res.data.success && res.data.data?.status === "SUCCESS") {
          setSuccessMessage(
            `Successfully reconciled. Difference: AED ${res.data.data.difference}`
          );
          setErrorMessage(""); // Clear any previous errors
        } else {
          setErrorMessage("Failed to reconcile. Please try again.");
          setSuccessMessage("");
        }
        // You can update your state here if needed
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage("An error occurred while reconciling.");
        setSuccessMessage("");
      });
  }

  const [actualCollectedMap, setActualCollectedMap] = useState({});

  // Update actualCollectedMap when the component mounts
  useEffect(() => {
    const initialMap = {};
    shipmentDetails.forEach((item) => {
      initialMap[item.bookingId] = item.cashCollected ?? 0;
    });
    setActualCollectedMap(initialMap);
  }, [shipmentDetails]);

  // Calculate the sum of all values in actualCollectedMap
  const getTotalActualCollected = () => {
    return shipmentDetails
      .filter((data) => data.latestStatus?.toLowerCase() === "delivered")
      .reduce((sum, data) => {
        const collectedAmount = actualCollectedMap[data.bookingId];
        return sum + (collectedAmount ? parseFloat(collectedAmount) : 0); // Safely sum the values
      }, 0);
  };

  const csvData2 = shipmentDetails.map((data) => ({
    bookingId: data.bookingId,
    latestStatus: data.latestStatus,
    lastTransitDate: new Date(data.lastUpdatedDate).toLocaleDateString(),
    lastTransitTime: new Date(data.lastUpdatedDate).toLocaleTimeString(),
    courier: `${driver} - ${data.courier}`,
    courier_team: driverdata.team,
    courier_zone: driverdata.zone,
    shipper: data.shipperDetails?.name || "",
    consignee: data.consigneeDetails?.name || "",
    paymentType: data.paymentType || "",
    codDetails:
      data.latestStatus?.toLowerCase() === "delivered"
        ? data.codDetails || ""
        : "",
    actualCollected:
      data.latestStatus?.toLowerCase() === "delivered"
        ? actualCollectedMap[data.bookingId] || 0
        : "",
    cashDifference:
      data.latestStatus?.toLowerCase() === "delivered"
        ? data.codDetails - actualCollectedMap[data.bookingId]
        : "",
    updatedBy: data.updatedBy || "",
  }));

  const [searchQuery, setSearchQuery] = useState("");

  const filteredDrivers = Array.isArray(drivers)
    ? drivers.filter((driver) =>
        driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const driverOptions = filteredDrivers.map((driver) => ({
    value: driver.driver_id,
    // label: driver.driver_name
    label: `${driver.driver_id} - ${driver.driver_name}`,
  }));

  const handleChange = (selectedOption) => {
    setdriverchosen(selectedOption.value);
  };

  return (
    <div>
      <div className="form-container">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="driver">Date:</label>
              <input
                type="date"
                id="date"
                value={datechosen}
                onChange={(e) => setdatechosen(e.target.value)}
              />
            </div>
            {/* Driver Selection */}

            <div className="form-group">
              <label htmlFor="driver">Select Driver:</label>
              <Select
                options={driverOptions}
                value={driverOptions.find(
                  (option) => option.value === scaninfo.driver
                )}
                onChange={handleChange}
                placeholder="Select a driver"
                onInputChange={(newValue) => setSearchQuery(newValue)} // Update search query
                isSearchable
                noOptionsMessage={() => "No drivers found"}
              />
            </div>
            {/* <div className="form-group">
              <label htmlFor="driver">Select Driver:</label>
              <select
                id="driver"
                value={driver}
                onChange={(e) => setdriverchosen(e.target.value)}
                // onChange={(e) => getRunsheet(e.target.value,e.target.options[e.target.selectedIndex].text)}

              >
                <option value="">Select a driver</option>
                {drivers && drivers.map((driver) => (
                  <option key={driver.driver_id} value={driver.driver_id}>
                    {driver.driver_name}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <a
                  onClick={getDetails}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Submit
                </a>
              </div>
            </div>
            <p style={{ color: "red", marginTop: "2%" }}>{errormsg}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-11">
            {loading && <p>Loading shipment details...</p>}
            {successMessage && (
              <div style={{ color: "green" }}>{successMessage}</div>
            )}
            {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}

            {shipmentDetails.length > 0 && (
              <div>
                <CSVLink
                  headers={csvHeaders2}
                  data={csvData2}
                  filename="driver_shipment_summary.csv"
                  className="btn btn-primary mb-3"
                  style={{ float: "right", fontSize: "10px" }}
                >
                  <i className="fa fa-download"></i>
                </CSVLink>
                <h4 style={{ textAlign: "left" }}>Track Summary:</h4>

                <div
                  className="shipdata"
                  style={{
                    background: "#5583af59",
                    maxHeight: "500px", // Adjust the height limit as needed
                    overflowY: "auto", // Enables vertical scrolling
                    // padding: '10px',   // Optional: Add some padding for better visuals
                    border: "1px solid #ccc", // Optional: Add a border for separation
                    // marginBottom:'3%'
                  }}
                >
                  <table className="table  table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>AWB</th>
                        <th>Status</th>
                        <th>Last Transit Date</th>
                        <th>Last Transit Time</th>
                        <th>Courier</th>
                        <th>Courier Team</th>
                        <th>Courier Zone</th>
                        <th>Shipper</th>
                        <th>Consignee</th>

                        <th>Payment Type</th>
                        <th>COD</th>
                        <th>Actual Collected</th>
                        <th>Cash Difference</th>
                        <th>Updated By</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {shipmentDetails.map((data, index) => (
                        <tr key={index}>
                          <td>
                            {" "}
                            {data.bookingId}
                            <br />
                            <p
                              style={{
                                display: "inline-block",
                                width: "15px",
                                height: "15px",
                                borderRadius: "50%",
                                backgroundColor:
                                  data.type === "PICK_UP"
                                    ? "blue"
                                    : data.type === "DROP"
                                    ? "green"
                                    : "gray",
                                color: "white",
                                textAlign: "center",
                                lineHeight: "15px", // To center the text vertically
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              {data.type === "PICK_UP"
                                ? "P"
                                : data.type === "DROP"
                                ? "D"
                                : ""}
                            </p>
                          </td>
                          <td>{data.latestStatus}</td>
                          <td>
                            {new Date(
                              data.lastUpdatedDate
                            ).toLocaleDateString()}
                          </td>
                          <td>
                            {new Date(
                              data.lastUpdatedDate
                            ).toLocaleTimeString()}
                          </td>

                          <td>{`${driver} - ${data.courier}`}</td>
                          <td>{driverdata.team}</td>
                          <td>{driverdata.zone}</td>
                          <td>{data.shipperDetails?.name || ""}</td>
                          <td>{data.consigneeDetails?.name || ""}</td>

                          <td>{data.paymentType}</td>
                          <td>
                            {data.latestStatus?.toLowerCase() === "delivered"
                              ? data.codDetails
                              : "0"}
                          </td>
                          <td>
                            <input
                              type="text"
                              value={
                                data.latestStatus?.toLowerCase() === "delivered"
                                  ? actualCollectedMap[data.bookingId] !==
                                    undefined
                                    ? actualCollectedMap[data.bookingId]
                                    : 0
                                  : 0
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                setActualCollectedMap((prev) => ({
                                  ...prev,
                                  [data.bookingId]: parseFloat(value) || 0, // Safely parse the value as a number
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {data.codDetails -
                              actualCollectedMap[data.bookingId]}
                          </td>
                          <td>{data.updatedBy}</td>
                          <td>
                            {sessionStorage.getItem("role") &&
                            sessionStorage.getItem("role") == "accounts" ? (
                              <a
                                className="editBtn"
                                onClick={() =>
                                  editStatus(data.bookingId, data.codDetails)
                                }
                              >
                                Reconcile <i className="fa fa-edit"></i>
                              </a>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ background: "#fff" }}>
                      <tr>
                        <td
                          colSpan="12"
                          style={{ textAlign: "right", fontWeight: "bold" }}
                        >
                          Total COD:
                        </td>
                        <td>{totalCod}</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td
                          colSpan="12"
                          style={{ textAlign: "right", fontWeight: "bold" }}
                        >
                          Actual Collected:
                        </td>
                        <td>{getTotalActualCollected()}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
